import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 7FFA202C-D65F-4F9C-AC9B-6A17AB4C611E
 * name currency-fra
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-fra.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CurrencyFraIcon = createSvgIcon(<><path d="M18 5V3H7V16H5V18H7V21H9V18H13V16H9V13H17V11H9V5H18Z" /></>, 'CurrencyFraIcon');
export default CurrencyFraIcon